/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Combo_Recipe_Add_BtnInputs */

const vi_combo_recipe_add_btn = /** @type {(inputs: Combo_Recipe_Add_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm`)
};

/**

* @param {Combo_Recipe_Add_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const combo_recipe_add_btn = /** @type {((inputs?: Combo_Recipe_Add_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Combo_Recipe_Add_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_combo_recipe_add_btn(inputs)
});